import { render, staticRenderFns } from "./CbsWidgetObjectLink.vue?vue&type=template&id=626eaa2b&scoped=true"
import script from "./CbsWidgetObjectLink.vue?vue&type=script&lang=js"
export * from "./CbsWidgetObjectLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626eaa2b",
  null
  
)

export default component.exports